// Infinite editorial marquee.
// variant: "dark" (ink stroke, for light backgrounds) | "light" (white stroke, for dark backgrounds) | "fill" (gradient fill)
export default function Marquee({
  text = "Believe. Become. Lead.",
  variant = "dark",
  animClass = "animate-marquee",
  className = "",
}) {
  const items = Array.from({ length: 6 });
  const textCls =
    variant === "fill" ? "text-gradient" : variant === "light" ? "stroke-text-light" : "stroke-text";
  return (
    <div className={`relative w-full overflow-hidden select-none ${className}`}>
      <div className={`flex whitespace-nowrap will-change-transform ${animClass}`}>
        {items.map((_, i) => (
          <span
            key={i}
            className={`font-display font-black uppercase tracking-tight text-[13vw] md:text-[9vw] leading-none pr-10 ${textCls}`}
          >
            {text}
            <span className="mx-8 text-coral" style={{ WebkitTextStroke: "0" }}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
